import React, {createContext, useContext, useState} from "react";

interface ModalContextType {
    showModalA: boolean;
    showModalB: boolean;
    showModalC: boolean;
    openModalA: () => void;
    openModalB: () => void;
    openModalC: () => void;
    closeModals: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [showModalA, setShowModalA] = useState(false);
    const [showModalB, setShowModalB] = useState(false);
    const [showModalC, setShowModalC] = useState(false);

    const openModalA = () => setShowModalA(true);
    const openModalB = () => {
        setShowModalA(false);
        setShowModalB(true);
    };
    const openModalC = () => {
        setShowModalB(false);
        setShowModalC(true);
    };
    const closeModals = () => {
        setShowModalA(false);
        setShowModalB(false);
        setShowModalC(false);
    };

    return (
        <ModalContext.Provider
            value={{showModalA, showModalB, showModalC, openModalA, openModalB, openModalC, closeModals}}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};
